<template>
  <div
    class="dgsgdsghzfzas41"
    :style="{
      '--brc': `${currentTheme === 'dark' ? 'rgb(76, 77, 93)' : 'rgb(220, 221, 222)'}`,
      '--ghr-bc': `${currentTheme === 'dark' ? '#3b3d42' : '#f7f9fc'}`,
      '--bar-bc': `${currentTheme === 'dark' ? '#818181' : '#eee'}`,
    }">
    <div class="ctr">
      <CSelect
        class="select-period"
        @CSelect_select_val="change_period"
        :options="period_options"
        :clearable="false"
        :mini="true"
        :default="current_period">
        报告期
      </CSelect>
      <CSelect
        class="select-type"
        @CSelect_select_val="change_period_type"
        :options="period_type_options"
        :clearable="false"
        :mini="true"
        :default="current_period_type">
        报告类型
      </CSelect>
      <CCascader
        :default="current_category"
        :checkStrictly="false"
        :multiple="true"
        :collapsetags="true"
        :options="category_cascader_options"
        @CCascader_select_val="change_category"
        >选择类别</CCascader
      >
      <CSelect
        :limit="100"
        :clearable="false"
        @CSelect_select_val="change_factor"
        :options="factor_options"
        multiple
        custWidth="200px"
        :default="current_factor">
        财务指标
      </CSelect>
      <CCascader
        :checkStrictly="false"
        :multiple="true"
        :isDelete="false"
        :default="reit_code"
        placeholder="请选择个股"
        :collapsetags="true"
        @CCascader_select_val="fnSelect_select_val_chart1_codename"
        :options="CODENAMEDATA">
        选择对比REITs
      </CCascader>
      <div class="btn-ddd">
        <CDownload :dButtonsDownloads="d_dsgs" @fnButtondownload="fnButtonDL6_1" />
      </div>
    </div>
    <div class="donw-tab-el">
      <el-table
        class="table1"
        :data="displayData"
        :header-cell-style="tableStyle"
        :span-method="objectSpanMethod"
        :row-class-name="getRowClass"
        @sort-change="sortChange"
        style="width: 100%">
        <el-table-column
          prop="reit_code"
          label="代码"
          width="100"
          fixed
          align="center"></el-table-column>
        <el-table-column prop="reit_name" label="证券简称" width="130" fixed>
          <template slot-scope="scope">
            <div v-if="scope.row.is_group_header" class="group-header-content">
              {{ scope.row.group_name }}
            </div>
            <span v-else class="reit-name-cell">{{ scope.row.reit_name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="category_1"
          label="资产类型"
          width="70"
          align="center"></el-table-column>
        <el-table-column v-for="f in factors" :key="f.key" align="center">
          <template slot="header">
            <div style="font-weight: 900">{{ f.name }} ({{ f.unit }})</div>
          </template>
          <el-table-column
            label="组内对比"
            min-width="240"
            sortable="custom"
            :prop="f.key + '_val'">
            <template slot-scope="scope">
              <div
                v-if="!scope.row.is_group_header && hasFactor(scope.row, f.key)"
                class="bar-container">
                <div class="bar-row" v-for="(vIdx, i) in [0, 1, 2]" :key="i">
                  <span class="bar-label">{{ getPeriod(scope.row, f.key, vIdx) }}</span>
                  <div class="bar-wrapper">
                    <div class="bar-track">
                      <div
                        :class="['bar-fill', ['bar-current', 'bar-prev', 'bar-yoy'][i]]"
                        :style="{ width: getWidth(scope.row, f.key, vIdx) + '%' }"></div>
                    </div>
                    <span :class="['bar-value', i === 0 ? 'val-current' : '']">{{
                      formatVal(getVal(scope.row, f.key, vIdx), f.unit)
                    }}</span>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="同比"
            min-width="80"
            align="center"
            sortable="custom"
            :prop="f.key + '_yoy'">
            <template slot-scope="scope">
              <div
                v-if="!scope.row.is_group_header && hasFactor(scope.row, f.key)"
                :class="[
                  'rate-cell',
                  isInvalid(getRate(scope.row, f.key, 'yoy'))
                    ? 'no-data'
                    : getRate(scope.row, f.key, 'yoy') > 0
                    ? 'up'
                    : 'down',
                ]">
                <template v-if="!isInvalid(getRate(scope.row, f.key, 'yoy'))">
                  <span>{{ getRate(scope.row, f.key, 'yoy') > 0 ? '▲' : '▼' }}</span>
                  {{ formatRate(getRate(scope.row, f.key, 'yoy')) }} </template
                ><span v-else>-</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="环比"
            min-width="80"
            align="center"
            sortable="custom"
            :prop="f.key + '_crr'">
            <template slot-scope="scope">
              <div
                v-if="!scope.row.is_group_header && hasFactor(scope.row, f.key)"
                :class="[
                  'rate-cell',
                  isInvalid(getRate(scope.row, f.key, 'crr'))
                    ? 'no-data'
                    : getRate(scope.row, f.key, 'crr') > 0
                    ? 'up'
                    : 'down',
                ]">
                <template v-if="!isInvalid(getRate(scope.row, f.key, 'crr'))">
                  <span>{{ getRate(scope.row, f.key, 'crr') > 0 ? '▲' : '▼' }}</span>
                  {{ formatRate(getRate(scope.row, f.key, 'crr')) }} </template
                ><span v-else>-</span>
              </div>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
    <el-table
      v-loading="loading"
      element-loading-text="数据量巨大，正在计算中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 1)"
      class="table1"
      :data="displayData"
      :header-cell-style="tableStyle"
      :span-method="objectSpanMethod"
      :row-class-name="getRowClass"
      @sort-change="sortChange"
      style="width: 100%"
      :height="`calc(var(--TABPANEHEIGHT) - var(--ROOTFONTFIZE) * (170 / 144) - ${fix_tab_h}px)`">
      <el-table-column
        prop="reit_code"
        label="代码"
        width="100"
        fixed
        align="center"></el-table-column>
      <el-table-column prop="reit_name" label="证券简称" width="130" fixed>
        <template slot-scope="scope">
          <div v-if="scope.row.is_group_header" class="group-header-content">
            {{ scope.row.group_name }}
          </div>
          <span v-else class="reit-name-cell">{{ scope.row.reit_name }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="category_1"
        label="资产类型"
        width="70"
        align="center"></el-table-column>
      <el-table-column v-for="f in factors" :key="f.key" align="center">
        <template slot="header">
          <div style="font-weight: 900">{{ f.name }} ({{ f.unit }})</div>
        </template>
        <el-table-column label="组内对比" min-width="240" sortable="custom" :prop="f.key + '_val'">
          <template slot-scope="scope">
            <div
              v-if="!scope.row.is_group_header && hasFactor(scope.row, f.key)"
              class="bar-container">
              <div class="bar-row" v-for="(vIdx, i) in [0, 1, 2]" :key="i">
                <span class="bar-label">{{ getPeriod(scope.row, f.key, vIdx) }}</span>
                <div class="bar-wrapper">
                  <div class="bar-track">
                    <div
                      :class="['bar-fill', ['bar-current', 'bar-prev', 'bar-yoy'][i]]"
                      :style="{ width: getWidth(scope.row, f.key, vIdx) + '%' }"></div>
                  </div>
                  <span :class="['bar-value', i === 0 ? 'val-current' : '']">{{
                    formatVal(getVal(scope.row, f.key, vIdx), f.unit)
                  }}</span>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="同比"
          min-width="100"
          align="center"
          sortable="custom"
          :prop="f.key + '_yoy'">
          <template slot-scope="scope">
            <div
              v-if="!scope.row.is_group_header && hasFactor(scope.row, f.key)"
              :class="[
                'rate-cell',
                isInvalid(getRate(scope.row, f.key, 'yoy'))
                  ? 'no-data'
                  : getRate(scope.row, f.key, 'yoy') > 0
                  ? 'up'
                  : 'down',
              ]">
              <template v-if="!isInvalid(getRate(scope.row, f.key, 'yoy'))">
                <span>{{ getRate(scope.row, f.key, 'yoy') > 0 ? '▲' : '▼' }}</span>
                {{ formatRate(getRate(scope.row, f.key, 'yoy')) }} </template
              ><span v-else>-</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="环比"
          min-width="100"
          align="center"
          sortable="custom"
          :prop="f.key + '_crr'">
          <template slot-scope="scope">
            <div
              v-if="!scope.row.is_group_header && hasFactor(scope.row, f.key)"
              :class="[
                'rate-cell',
                isInvalid(getRate(scope.row, f.key, 'crr'))
                  ? 'no-data'
                  : getRate(scope.row, f.key, 'crr') > 0
                  ? 'up'
                  : 'down',
              ]">
              <template v-if="!isInvalid(getRate(scope.row, f.key, 'crr'))">
                <span>{{ getRate(scope.row, f.key, 'crr') > 0 ? '▲' : '▼' }}</span>
                {{ formatRate(getRate(scope.row, f.key, 'crr')) }} </template
              ><span v-else>-</span>
            </div>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { debounce } from '@/utils';
import { loadReportCatalog } from '@/services/reportCatalog';
import { convertToCascaderOptions, buildCascaderOptions } from '@/utils/cascader';
import { fnReturnTableStyle, fnDownloadBgc } from '@/utils/util';
import CSelect from '@/components/Basic/CSelect';
import CCascader from '@/components/Basic/CCascader';
import CDownload from '@/components/Basic/CButtons_download';
import html2canvas from 'html2canvas';
import * as XLSX from 'xlsx';

export default {
  name: 'First',
  components: { CSelect, CCascader, CDownload },
  data() {
    const REITsNAME = JSON.parse(localStorage.getItem('REITsNAME2')) || [];
    const period5 = JSON.parse(localStorage.getItem('period5') || '{}');
    const CATEGORYDATA = JSON.parse(localStorage.getItem('FINALLYCATEGORY')) || [];
    const _factors = [
      { key: 'revenue', name: '营业收入', unit: '万元' },
      { key: 'ebitda', name: 'EBITDA', unit: '万元' },
      { key: 'distributable_amount_period', name: '可供分配', unit: '万元' },
      { key: 'div_yield', name: '分派率', unit: '%' },
    ];
    return {
      fix_tab_h: 2,
      loading: true,
      period5: Object.freeze(period5),
      search: '',
      sortConfig: { prop: '', order: '' },
      raw: {
        factors: [],
        columns: [],
        data: [],
        max_vals_by_cat: {},
      },
      factors: _factors,
      current_period: '',
      period_map: {
        quarterly: [...(period5.quarterly || [])].reverse(),
        midterm: [...(period5.midterm || [])].reverse(),
        annual: [...(period5.annual || [])].reverse(),
      },
      period_options: [],
      current_period_type: 'quarterly',
      period_type_options: Object.freeze([
        {
          label: '季报',
          value: 'quarterly',
        },
        {
          label: '中报',
          value: 'midterm',
        },
        {
          label: '年报',
          value: 'annual',
        },
      ]),
      category_cascader_options: Object.freeze(CATEGORYDATA),
      current_category: ['公募REITs'],
      factor_options: _factors.map((e) => ({ label: e.name, value: e.key })),
      current_factor: ['revenue', 'ebitda', 'distributable_amount_period', 'div_yield'],
      d_dsgs: [
        {
          id: '241020',
          name: '下载图片',
        },
        {
          id: '241020',
          name: '下载表格',
        },
      ],
      CODENAMEDATA: Object.freeze(REITsNAME),
      reit_code: [],
    };
  },
  computed: {
    qsStr() {
      const rp_period = this.current_period;
      const rp_type = this.current_period_type;
      const factor = this.current_factor.join('&factor=');
      const r_type = this.current_category.join('&r_type=');
      const codes = this.reit_code.join('&codes=');
      return `rp_period=${rp_period}&rp_type=${rp_type}&factor=${factor}&r_type=${r_type}&codes=${codes}`;
    },
    currentTheme() {
      return this.$store.state.theme; // 从Vuex中获取当前的主题值
    },
    tableStyle() {
      const val = this.$store.state.theme === 'dark';
      return () => fnReturnTableStyle(val);
    },
    displayData: function () {
      var self = this;
      var filtered = this.raw.data.filter(function (d) {
        var s = self.search.toLowerCase();
        return (
          !s ||
          (d.reit_name && d.reit_name.toLowerCase().indexOf(s) !== -1) ||
          (d.reit_code && d.reit_code.toLowerCase().indexOf(s) !== -1) ||
          (d.category_2 && d.category_2.toLowerCase().indexOf(s) !== -1)
        );
      });
      var groups = {};
      filtered.forEach(function (item) {
        var cat = item.category_2 || '其他';
        if (!groups[cat]) groups[cat] = [];
        groups[cat].push(item);
      });
      var sortedKeys = Object.keys(groups).sort();
      if (this.sortConfig.prop && this.sortConfig.order) {
        var isDesc = this.sortConfig.order === 'descending',
          prop = this.sortConfig.prop;
        sortedKeys.forEach(function (cat) {
          groups[cat].sort(function (a, b) {
            var va = self.getSortVal(a, prop),
              vb = self.getSortVal(b, prop);
            return isDesc ? vb - va : va - vb;
          });
        });
        sortedKeys.sort(function (a, b) {
          var va = self.getSortVal(groups[a][0], prop),
            vb = self.getSortVal(groups[b][0], prop);
          return isDesc ? vb - va : va - vb;
        });
      }
      var res = [];
      sortedKeys.forEach(function (cat) {
        res.push({ is_group_header: true, group_name: cat });
        res.push.apply(res, groups[cat]);
      });
      return res;
    },
  },
  watch: {
    qsStr() {
      if (!this.current_period) return;
      this._getData();
    },
  },
  created() {
    this.initReportCatalog();
    this.initPeriodOptions();
  },
  methods: {
    async initReportCatalog() {
      try {
        const funds = await loadReportCatalog(this.$https);
        const userGroups = this.CODENAMEDATA.filter(node => node.label === '我的自选');
        const combos = this.category_cascader_options.filter(node => node.value === '组合板块');
        this.CODENAMEDATA = Object.freeze([...convertToCascaderOptions(funds), ...userGroups]);
        this.category_cascader_options = Object.freeze([...buildCascaderOptions(funds), ...combos]);
      } catch (error) {
        this.$message.error('财报基金目录加载失败，请刷新重试');
      }
    },
    fnSelect_select_val_chart1_codename(val) {
      val = val.filter((node) => {
        return node.includes('.');
      });

      this.reit_code = Object.freeze(val);
    },
    fnButtonDL6_4_1() {
      let el = document.querySelector('.donw-tab-el');
      // console.clear();
      // console.log(el);
      let h = el.scrollHeight;
      let w = el.scrollWidth;
      // 第一个参数是需要生成截图的元素,第二个是自己需要配置的参数,宽高等
      html2canvas(el, {
        height: h + 20,
        width: w,
        backgroundColor: fnDownloadBgc(this.currentTheme),
        useCORS: true,
        scale: 1,
      }).then((canvas) => {
        let url = canvas.toDataURL('image/png');
        var a = document.createElement('a'); // 生成一个a元素
        var event = new MouseEvent('click'); // 创建一个单击事件
        a.download = 'REITs_Finance_' + this.current_period; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      });
    },
    fnButtonDL6_1(t) {
      if (t === '下载表格') {
        this.downloadExcel();
      }
      if (t === '下载图片') {
        this.fnButtonDL6_4_1();
      }
    },
    change_factor(v) {
      this.current_factor = v;
    },
    change_category(val) {
      if (!val.length) {
        this.$message.error('请选择类别');
        return;
      }
      this.current_category = val;
    },
    getFallbackPeriods(v) {
      return [...(this.period5[v] || [])].reverse();
    },
    normalizePeriodMap(data) {
      const source =
        data && !Array.isArray(data) && data.data && !Array.isArray(data.data) ? data.data : data;
      return ['quarterly', 'midterm', 'annual'].reduce((acc, key) => {
        const list = source && Array.isArray(source[key]) ? source[key] : [];
        acc[key] = list
          .map((item) => {
            if (typeof item === 'string') return item;
            return (item && item.value) || (item && item.label) || '';
          })
          .filter(Boolean);
        return acc;
      }, {});
    },
    hasPeriodMap(periodMap) {
      return Object.values(periodMap).some((list) => list.length);
    },
    toLegacyPeriodMap(periodMap) {
      return ['quarterly', 'midterm', 'annual'].reduce((acc, key) => {
        acc[key] = [...((periodMap && periodMap[key]) || [])].reverse();
        return acc;
      }, {});
    },
    resetRaw() {
      this.raw = {
        factors: [],
        columns: [],
        data: [],
        max_vals_by_cat: {},
      };
    },
    async initPeriodOptions() {
      try {
        const { data } = await this.$https.get('/api/v2/conghua/findata/period/button');
        const periodMap = this.normalizePeriodMap(data);
        if (this.hasPeriodMap(periodMap)) {
          this.period_map = periodMap;
          localStorage.setItem('period5', JSON.stringify(this.toLegacyPeriodMap(periodMap)));
        }
      } catch (error) {
        if (!this.hasPeriodMap(this.period_map)) {
          this.$message.error('Failed to load report periods');
        }
      }

      this.change_period_type(this.current_period_type);
    },
    change_period_type(v) {
      const periods = [...(this.period_map[v] || this.getFallbackPeriods(v))];
      this.current_period = '';
      this.current_period_type = v;
      this.period_options = Object.freeze(periods.map((e) => ({ label: e, value: e })));
      this.current_period = periods[0] || '';

      if (!this.current_period) {
        this.resetRaw();
      }
    },
    change_period(v) {
      this.current_period = v;
    },
    _getData: debounce(function () {
      this.getData();
    }),
    async getData() {
      if (!this.current_period) return;
      this.loading = true;
      const { data } = await this.$https.get(`/api/v2_5/get_fin_data_v2?${this.qsStr}`);
      if (data.code !== 200) {
        this.loading = false;
        return this.$message.error(data.msg);
      }
      this.loading = false;
      this.raw = data.data;
      setTimeout(() => {
        this.fix_tab_h = 0;
      }, 200);
    },
    downloadExcel: function () {
      var exportData = [];
      var h = ['证券代码', '证券简称', '资产类型'];
      var firstItem = this.raw.data[0];
      this.factors.forEach((f) => {
        var ps = firstItem[f.key + '_periods'] || ['去年同期', '上期', '本期'];
        h.push(
          f.name + ' ' + ps[2],
          f.name + ' ' + ps[1],
          f.name + ' ' + ps[0],
          f.name + '(同比)',
          f.name + '(环比)'
        );
      });
      exportData.push(h);
      this.displayData.forEach((row) => {
        if (row.is_group_header) exportData.push([row.group_name]);
        else {
          var item = [row.reit_code, row.reit_name, row.category_1];
          this.factors.forEach((f) => {
            var vs = row[f.key + '_values'] || [null, null, null];
            var formatValExcel = (v) => {
              if (v === null || v === undefined) return null;
              return f.unit === '%' ? v * 100 : v / 10000;
            };
            item.push(formatValExcel(vs[2]), formatValExcel(vs[1]), formatValExcel(vs[0]));
            item.push(
              this.formatRateWithArrow(this.getRate(row, f.key, 'yoy')),
              this.formatRateWithArrow(this.getRate(row, f.key, 'crr'))
            );
          });
          exportData.push(item);
        }
      });
      var ws = XLSX.utils.aoa_to_sheet(exportData);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'REITs财务数据');
      XLSX.writeFile(wb, 'REITs_Finance_' + this.current_period + '.xlsx');
    },
    getSortVal: function (item, prop) {
      var factorKey = prop.split('_')[0],
        sortType = prop.split('_')[1];
      if (sortType === 'val') {
        var idx = (item[factorKey + '_periods'] || []).indexOf(this.current_period);
        var v =
          idx !== -1
            ? (item[factorKey + '_values'] || [])[idx]
            : (item[factorKey + '_values'] || [0])[0];
        return v === null || v === undefined || isNaN(v) ? -999999999 : v;
      }
      var r = item[factorKey + '_' + sortType];
      return r === null || r === undefined || isNaN(r) ? -999999999 : r;
    },
    sortChange: function (c) {
      this.sortConfig = c;
    },
    resetSort: function () {
      this.sortConfig = { prop: '', order: '' };
    },
    objectSpanMethod: function (c) {
      if (c.row.is_group_header)
        return c.columnIndex === 1
          ? { rowspan: 1, colspan: 18 }
          : c.columnIndex === 0
          ? { rowspan: 0, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
    },
    getRowClass: function (c) {
      return c.row.is_group_header ? 'group-header-row' : '';
    },
    hasFactor: function (r, k) {
      return !!r[k + '_values'];
    },
    getVal: function (r, k, i) {
      return r[k + '_values'] ? r[k + '_values'][i] : null;
    },
    getPeriod: function (r, k, i) {
      return r[k + '_periods'] ? r[k + '_periods'][i] : '';
    },
    getRate: function (r, k, t) {
      return r[k + '_' + t];
    },
    isInvalid: function (v) {
      return v === null || v === undefined || isNaN(v) || v === '';
    },
    formatVal: function (v, u) {
      if (this.isInvalid(v)) return '';
      return u === '%'
        ? (v * 100).toFixed(2) + '%'
        : (v / 10000).toLocaleString(undefined, { maximumFractionDigits: 0 });
    },
    formatRate: function (v) {
      return this.isInvalid(v) ? '-' : Math.abs(v * 100).toFixed(1) + '%';
    },
    formatRateWithArrow: function (v) {
      if (this.isInvalid(v)) return '-';
      return (v > 0 ? '+' : '-') + this.formatRate(v);
    },
    getWidth: function (row, key, idx) {
      var v = this.getVal(row, key, idx);
      if (this.isInvalid(v)) return 0;
      var cat = row.category_2 || '其他';
      var max = (this.raw.max_vals_by_cat[cat] && this.raw.max_vals_by_cat[cat][key]) || 1;
      return Math.min(100, (v / max) * 100);
    },
  },
};
</script>

<style scoped lang="less">
.dgsgdsghzfzas41 {
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
  .ctr {
    display: flex;
    gap: calc(var(--ROOTFONTFIZE) * (16 / 144));
    padding-bottom: calc(var(--ROOTFONTFIZE) * (20 / 144));
    .select-type {
      order: -2;
    }
    .select-period {
      order: -1;
    }
    .btn-ddd {
      margin-left: auto;
      margin-right: 0;
    }
  }
  .donw-tab-el {
    position: absolute;
    left: -9999px;
    top: -9999px;
  }

  /deep/.group-header-row td {
    background-color: var(--ghr-bc) !important;
  }
  .group-header-content {
    font-weight: 900;
  }
  .bar-container {
    display: flex;
    flex-direction: column;
    gap: 3px;
    padding: 2px 0;
  }
  .bar-row {
    display: flex;
    align-items: center;
    height: 16px;
  }
  .bar-label {
    color: #8c8c8c;
    width: 5em;
    white-space: nowrap;
    text-align: left;
    flex: none;
    // margin-right: 8px;
    font-weight: 600;
  }
  .bar-wrapper {
    flex-grow: 1;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .bar-track {
    // flex-grow: 1;
    height: 14px;
    // background-color: #fafafa;
    background-color: transparent;
    border: 1px solid var(--bar-bc);
    border-radius: 2px;
    position: relative;
    width: 80px;
    overflow: hidden;
  }
  .bar-fill {
    height: 100%;
    border-radius: 0px;
    transition: width 0.5s ease;
  }
  .bar-value {
    white-space: nowrap;
    // font-size: 10px;
    font-weight: 800;
    // font-family: monospace;
    // min-width: 45px;
  }
  .bar-current {
    background-color: #28b1c9;
  }
  .val-current {
    color: #28b1c9;
  }
  .bar-prev {
    background-color: #b0b0b0;
  }
  .bar-yoy {
    background-color: #97e1e9;
  }
  .rate-cell {
    display: flex;
    justify-content: center;
    white-space: nowrap;
    font-weight: 900;
    font-size: 12px;
    padding: 1px 4px;
    border-radius: 2px;
    display: inline-flex;
    align-items: center;
    gap: 2px;
    min-width: 70px;
  }
  .up {
    color: #ff4d4f;
    background-color: #fff1f0;
  }
  .down {
    color: #52c41a;
    background-color: #f6ffed;
  }
}

/deep/.el-table__fixed::before {
  background-color: transparent !important;
}

/* el-table start */
/* ::v-deep .el-table {
  overflow: hidden auto !important;
} */
::v-deep .table1 table,
.el-table--border,
.el-table--group {
  border: none;
}
::v-deep .el-table--border .el-table__cell {
  // border-right: none;
  border-right-color: var(--brc);
}

::v-deep .el-table__body .el-table__row .el-table__cell {
  background-color: var(--table_bgc);
  color: var(--table_color);
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
  height: calc(var(--ROOTFONTFIZE) * (60 / 144));
  border-bottom: calc(var(--ROOTFONTFIZE) * (1 / 144)) solid var(--table_brc);
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background-color: var(--table_bgc_hover);
  /* background-color: var(--table_color_hover); */
  color: var(--table_color_hover);
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell:hover {
  cursor: pointer;
}

::v-deep .el-table::before,
.el-table::after {
  background-color: var(--table_bgc);
}

::v-deep .el-table {
  border-bottom: none !important;
  background-color: var(--table_bgc);
}

/* el-table end */
</style>
